import CaretDown16 from '@carbon/icons-react/es/caret--down/16';
import CaretUp16 from '@carbon/icons-react/es/caret--up/16';
import React, { useCallback, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Collapse, Panel, PanelHeaderTitle } from 'components/atoms/collapse';
import styles from 'components/organisms/task-pane/task-detail/task-detail.module.css';
import { PrereleaseFeature, useFeature } from 'hooks/use-feature';
import { ArchiveProjectControl } from './archive-control';
import { ProjectsToTemplatesControl } from './create-template-control';
import { DeleteProjectControl } from './delete-control';
import { StyledProjectArchiveDeleteControls } from './styles';

const Wrapper = styled.div``;

const PanelHeaderTitleWrapper = styled.div`
  padding: var(--layout-01);
  font-size: var(--heading-6-size);
`;

const ProjectControlsWrapper = styled.div`
  padding: var(--layout-01);
`;

export const ProjectControls = () => {
  const ref = useRef<null | HTMLDivElement>(null);

  const isProjectsToTemplatesEnabled = useFeature(
    PrereleaseFeature.ProjectToTemplates,
  );

  const [collapseActiveKeys, setCollapseActiveKeys] = useState<
    string[] | string
  >([]);

  const _onChange = useCallback((_keys) => {
    setCollapseActiveKeys(_keys);
    if (_keys.length > 0) {
      window.setTimeout(() => {
        ref.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'end',
          inline: 'nearest',
        });
      }, 250);
    }
  }, []);

  return (
    <Collapse
      className={styles.collapse}
      activeKey={collapseActiveKeys}
      onChange={_onChange}
      expandIconPosition="right"
      expandIcon={({ isActive }) => {
        return isActive ? <CaretUp16 /> : <CaretDown16 />;
      }}
    >
      <Panel
        key="Advance Settings"
        className={styles.section__panel}
        header={
          <PanelHeaderTitleWrapper>
            <PanelHeaderTitle
              title={<FormattedMessage id="advanced_settings" />}
            />
          </PanelHeaderTitleWrapper>
        }
      >
        <ProjectControlsWrapper>
          <StyledProjectArchiveDeleteControls>
            <>
              <ArchiveProjectControl />
              <DeleteProjectControl />
            </>
          </StyledProjectArchiveDeleteControls>

          {isProjectsToTemplatesEnabled ? (
            <Wrapper ref={ref}>
              <ProjectsToTemplatesControl />
            </Wrapper>
          ) : null}
        </ProjectControlsWrapper>
      </Panel>
    </Collapse>
  );
};
